export const WORKSHOP_CATEGORIES = [
  {
    value: 'CULTURE',
    slug: 'culture',
    label: 'Culture',
    labelKr: '문화',
    title: 'Cultural Explorer',
    titleKr: '문화 탐험가',
  },
  {
    value: 'CAREER',
    slug: 'career',
    label: 'Career',
    labelKr: '커리어',
    title: 'Career Builder',
    titleKr: '커리어 빌더',
  },
  {
    value: 'ETC',
    slug: 'etc',
    label: 'etc',
    labelKr: '기타',
    title: 'More Workshops',
    titleKr: '그 외 워크숍',
  },
];

export const DEFAULT_WORKSHOP_CATEGORY = WORKSHOP_CATEGORIES[0];

export const WORKSHOP_LIST_BASE = '/community/kpathport';

export const getWorkshopCategory = (valueOrSlug) => {
  const key = String(valueOrSlug ?? '').trim().toLowerCase();
  if (!key) return null;
  return (
    WORKSHOP_CATEGORIES.find(
      (item) => item.slug === key || item.value.toLowerCase() === key,
    ) ?? null
  );
};

export const getWorkshopCategoryLabel = (value) =>
  (getWorkshopCategory(value) ?? DEFAULT_WORKSHOP_CATEGORY).label;

export const getWorkshopListPath = (valueOrSlug) =>
  `${WORKSHOP_LIST_BASE}/${
    (getWorkshopCategory(valueOrSlug) ?? DEFAULT_WORKSHOP_CATEGORY).slug
  }`;
